import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Route guard to protect authenticated-only routes
 */
export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isAuthenticated()) {
        return true;
    }

    // Store intended URL for redirect after login
    const returnUrl = state.url;
    router.navigate(['/auth/login'], {
        queryParams: { returnUrl }
    });
    return false;
};

/**
 * Guard to prevent authenticated users from accessing auth pages (login/register)
 */
export const noAuthGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
        return true;
    }

    // Already logged in, redirect to home
    router.navigate(['/']);
    return false;
};
